import React from "react";
import { ListItem, ListItemText, IconButton, ListItemAvatar, Avatar, } from "@mui/material";
import { Delete, FilePresent } from "@mui/icons-material";
var UploadItem = function (props) {
    var file = props.file, onRemoveItem = props.onRemoveItem;
    return (React.createElement(ListItem, { secondaryAction: React.createElement(IconButton, { edge: "end", "aria-label": "delete", onClick: function () {
                onRemoveItem(file.id);
            } },
            React.createElement(Delete, null)) },
        React.createElement(ListItemAvatar, null,
            React.createElement(Avatar, null,
                React.createElement(FilePresent, null))),
        React.createElement(ListItemText, { primary: "".concat(file.file.name), secondary: "".concat(Math.floor(file.file.size / 1000), "kb") })));
};
export default UploadItem;
